import * as React from 'react';

import Files from './Files';

export const files = () => <Files />;

export default {
    title: 'Illustration/Files',
    component: Files,
    parameters: {
        notes: "`import Files from 'box-ui-elements/es/illustration/Files';`",
    },
};
